import React from 'react';

import { RadioGroup as MuiRadioGroup } from '@mui/material';
import styled from 'styled-components';

import InputSubText from './InputSubText';
import { StyledLabel } from './styles';
import { type RadioGroupProps } from './types';

const StyledMuiRadioGroup = styled(MuiRadioGroup)<RadioGroupProps>`
    border: 1px solid ${(props) => (props.errorMessage ? props.theme.colors.error : 'transparent')};
    border-radius: 4px;
    padding: 0.5rem 0.75rem;
`;

const RadioGroup = React.forwardRef((props: RadioGroupProps, ref) => {
    const { helperText, errorMessage, label, children, ...radioGroupProps } = props;

    return (
        <>
            {label && <StyledLabel>{label}</StyledLabel>}
            <StyledMuiRadioGroup {...radioGroupProps} ref={ref}>
                {children}
            </StyledMuiRadioGroup>
            <InputSubText name={props.name} helperText={helperText} errorMessage={errorMessage} />
        </>
    );
});

export default RadioGroup;
